import { Typography } from '@material-ui/core';

import React, { MutableRefObject, useContext } from 'react';
import { CanvasWrapper } from './Canvas.style';
import MainInfo from 'components/MainInfo';
import TimelineChart from 'components/TimelineChart';
import Context from 'context';
import { Colors } from 'type';

type CanvasProps = {
  chartRef: MutableRefObject<HTMLDivElement | null>;
};
const Canvas = ({ chartRef }: CanvasProps): JSX.Element => {
  const { colors } = useContext(Context);
  return (
    <CanvasWrapper backgroundColor={colors[Colors.Background]}>
      <div ref={chartRef} style={{ position: 'relative', height: '800px' }}>
        <MainInfo />
        <TimelineChart />
        <div>
          <Typography
            variant='body1'
            style={{
              opacity: '0.75',
              position: 'absolute',
              bottom: '8px',
              right: '16px',
              color: colors[Colors.Tertiary],
            }}
          >
            สร้างไทมไลน์ได้ที่: timeline.pariyawit.com
          </Typography>
        </div>
      </div>
    </CanvasWrapper>
  );
};

export default Canvas;
